import { CategoryType, Language, MainCategories } from '@shared/openapi/jaaluu-api';
import { Ref, ref } from 'vue';
import { language } from '.';
import { CATEGORIES_EN } from './categories/en';
import { SubCategory } from './category';

const PROGRESS_LS_KEY = 'progress';

export interface Progress {
  pct: number;
  done: string[];
}

export default () => {
  const { langForeign, langNative } = language.state;
  const showCategoryChapterDone = ref(false);
  const completedSubCategory = ref('');

  const progress: Ref<
    | {
        [valueof in Language]: {
          [valueof in Language]: {
            [valueof in CategoryType]: {
              [valueof in MainCategories]: Record<SubCategory, Progress>;
            };
          };
        };
      }
    | null
  > = ref(null);

  const initProgressState = () => {
    let _progressLs = null;
    if (localStorage.getItem(PROGRESS_LS_KEY)) {
      _progressLs = JSON.parse(localStorage.getItem(PROGRESS_LS_KEY) || '');
    }
    const _progress: any = {};
    for (const langForeign of Object.values(Language)) {
      _progress[langForeign] = {};
      for (const langNative of Object.values(Language)) {
        _progress[langForeign][langNative] = {};
        for (const categoryType of Object.values(CategoryType) as CategoryType[]) {
          _progress[langForeign][langNative][categoryType] = {};
          for (const mainCategory of Object.values(MainCategories) as MainCategories[]) {
            _progress[langForeign][langNative][categoryType][mainCategory] = {};
            for (const subCategory in CATEGORIES_EN[mainCategory].categories) {
              if (
                _progressLs &&
                _progressLs[langForeign] &&
                _progressLs[langForeign][langNative] &&
                _progressLs[langForeign][langNative][categoryType] &&
                _progressLs[langForeign][langNative][categoryType][mainCategory] &&
                _progressLs[langForeign][langNative][categoryType][mainCategory][subCategory]
              ) {
                _progress[langForeign][langNative][categoryType][mainCategory][subCategory] =
                  _progressLs[langForeign][langNative][categoryType][mainCategory][subCategory];
              } else {
                _progress[langForeign][langNative][categoryType][mainCategory][subCategory] = {
                  pct: 0,
                  done: []
                };
              }
            }
          }
        }
      }
    }
    progress.value = _progress;
  };

  const saveProgressToLs = () => {
    if (progress.value) {
      localStorage.setItem(PROGRESS_LS_KEY, JSON.stringify(progress.value));
    } 
  };

  const getSubProgress = (
    mainCategory: MainCategories,
    subCategory: SubCategory,
    categoryType: CategoryType
  ) => {
    if (!langForeign.value || !langNative.value || !progress.value) return { done: [], pct: 0 };
    return progress.value[langForeign.value][langNative.value][categoryType][mainCategory][subCategory];
  };

  const getMainProgress = (mainCategory: MainCategories, categoryType: CategoryType) => {
    if (!langForeign.value || !langNative.value || !progress.value) return { done: [], pct: 0 };
    const subCategories = CATEGORIES_EN[mainCategory].categories;
    let total = 0;
    for (const subCategory in subCategories) {
      const subProgress = getSubProgress(mainCategory, subCategory as SubCategory, categoryType);
      total += subProgress.pct;
    }
    return { done: [], pct: total / Object.keys(subCategories).length } as Progress;
  };


  const resetSubProgress = (
    mainCategory: MainCategories,
    subCategory: SubCategory,
    categoryType: CategoryType
  ) => {
    if (!langForeign.value || !langNative.value || !progress.value) return;
    progress.value[langForeign.value][langNative.value][categoryType][mainCategory][subCategory] = {
      pct: 0,
      done: []
    };
    saveProgressToLs();
  };

  return {
    state: { progress, showCategoryChapterDone, completedSubCategory },
    funcs: {
      initProgressState,
      getSubProgress,
      getMainProgress,
      saveProgressToLs,
      resetSubProgress
    }
  };
};
